var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkewb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.573 105.573H394.426V394.426H105.573z",
    transform: "rotate(45.001 250.004 249.998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43.5L230.5 43.5 43 231z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 456.5L43 269 230.5 456.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M457 456.5L269.5 456.5 457 269z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M457 43.5L457 231 269.5 43.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkewb);
export default __webpack_public_path__ + "static/media/skewb.1b13c328c8e34e1363f44eb938c32ffd.svg";
export { ForwardRef as ReactComponent };